/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './table';
export * from './cell';
export * from './row';
export * from './table-module';
export * from './sticky-styler';
export * from './can-stick';
export * from './text-column';
export * from './tokens';

/** Re-export DataSource for a more intuitive experience for users of just the table. */
export {DataSource} from '@angular/cdk/collections';
